import type { Translation } from '../translations.types';

const translations: Translation = {
  logout: 'Uitloggen',
  openMenu: 'Menu openen',
  closeMenu: 'Menu sluiten',
  author: 'Geplaatst door',
  'add-review': 'Mmm! Deel je food verhaal!',
  'add-review-to-food': 'Vertel over je {{food}} ervaring',
  food: {
    title: 'Eten',
    gourmets: '{{food}} Fans',
    bestPlaces: 'Beste Plekken voor {{food}}',
    gourmetsSectionDescription:
      'Check wie alles weet over {{food}}! Onze foodies zijn gerangschikt op hoe vaak ze het hebben geprobeerd en wat ze ervan vonden.',
    bestPlacesSectionDescription:
      'Op zoek naar geweldige {{food}}? Deze plekken zijn beoordeeld door mensen die er verstand van hebben!',
    beTheFirstReviewer: {
      title: 'Wees de eerste die {{foodName}} beoordeelt!',
      description: 'Jouw smaakervaring telt! Deel je beoordeling en help andere fijnproevers dit gerecht te ontdekken.',
      button: 'Schrijf de eerste beoordeling'
    }
  },
  seo: {
    keywords: {
      food: 'food',
      cuisine: 'cuisine',
      reviews: 'reviews',
      rating: 'rating',
      restaurants: 'restaurants',
      dining: 'dining',
    },
    food: {
      title: '{{foodName}} Review',
      description:
        'Discover the best places to eat {{foodName}}. Read honest reviews, ratings, and find where to enjoy the most delicious {{foodName}} near you on BiteCritic.',
      defaultDescription:
        'Discover {{foodName}} - reviews, ratings, and where to find the best {{foodName}} near you.',
    },
    place: {
      defaultDescription:
        'Explore {{placeName}} - reviews, ratings, and popular dishes at this location.',
      cityDescription:
        'Explore {{placeName}} in {{cityName}} - reviews, ratings, and popular dishes at this location.',
    },
    review: {
      defaultDescription:
        '{{username}} reviewed {{foodName}} at {{placeName}}. Rated {{rating}}/{{maxRating}}',
      foodTitle: '{{foodName}} Review at {{placeName}} - {{rating}}/10',
      placeTitle: '{{placeName}} Review - {{rating}}/10',
      metaDescription:
        "Read {{username}}'s detailed review of {{foodName}} at {{placeName}}. Rating: {{rating}}/10. Find out what makes this {{type}} special.",
      authorTitle: "{{username}}'s Review of {{foodName}} at {{placeName}}",
      ratingScale: 'Rating scale: 0-10',
      reviewedType: {
        food: 'Food',
        restaurant: 'Restaurant',
        product: 'Product',
      },
    },
    user: {
      defaultDescription:
        "Explore {{username}}'s culinary journey - reviews, favorite dishes, and food adventures.",
    },
    category: {
      defaultDescription:
        'Explore {{categoryName}} dishes - discover the best food, reviews, and where to find them near you.',
    },
    meta: {
      siteName: 'BiteCritic',
      defaultTitle: 'BiteCritic - Discover and Share Food Experiences',
      defaultDescription:
        'Discover and review the best food and restaurants near you',
      defaultKeywords:
        'food, restaurants, reviews, dining, cuisine, food critics',
    },
  },
  drink: 'Drank',
  place: 'Plaats',
  'where-did-you-eat': 'Waar heb je dit gegeten?',
  'what-did-you-eat': 'Wat heb je geprobeerd?',
  localeCurrency: 'Lokale valuta',
  category: 'Categorie',
  name: 'Naam',
  rating: 'Jouw Score',
  welcome_modal: {
    title: 'Welkom bij BiteCritic!',
    subtitle: 'Ontdek je volgende favoriete hapje',
    description:
      'BiteCritic is een gemeenschap van voedselliefhebbers die hun ervaringen delen en het eten beoordelen dat ze hebben geprobeerd.',
    features: {
      title: 'Met BiteCritic kun je:',
      rate: 'Gerechten beoordelen op smaak, niet alleen restaurants',
      discover:
        'Nieuwe gerechten ontdekken op basis van authentieke beoordelingen',
      connect: 'Contact maken met andere voedselliefhebbers',
      track: 'Bijhouden welke gerechten je wilt proberen',
    },
    not_now: 'Niet nu',
    join_now: 'Doe mee',
  },
  review: {
    label: 'Jouw Beoordeling',
    writingIn: 'Ik schrijf deze recensie in',
    success: 'Je verhaal is live!',
    error: 'Oeps! Er ging iets mis bij het delen van je verhaal',
    foodReviewTitle:
      '{{foodName}} recensie door {{username}} bij {{placeName}}, {{city}}',
    drinkReviewTitle:
      '{{drinkName}} recensie door {{username}} bij {{placeName}}, {{city}}',
  },
  previous: 'Terug',
  next: 'Verder',
  'submit-review': 'Deel Je Verhaal',
  cancel: 'Laat Maar',
  type: 'Wat Voor Soort',
  'add-food-review': 'Wat heb je gegeten?',
  'select-food': 'Kies je gerecht',
  cost: 'Hoeveel?',
  'rating-explanation': 'Beoordeel je ervaring met dit gerecht.',
  'write-your-review': 'Vertel het verhaal...',
  'visited-at': 'Wanneer was je er?',
  reviews: {
    noReviews: 'Geen beoordelingen gevonden',
    readFull: 'Lees het hele verhaal',
    showTranslation: 'Toon vertaling',
    showOriginal: 'Toon origineel',
    translatedFrom: 'Vertaald uit het {{language}}',
    filters: {
      title: 'Filters',
      apply: 'Filters Toepassen',
      rating: 'Beoordeling',
      cost: 'Prijs',
      startDate: 'Van',
      endDate: 'Tot',
      location: 'Locatie',
      radius: 'Zoekradius (km)',
      sort: {
        label: 'Sorteren op',
        newest: 'Nieuwste Eerst',
        oldest: 'Oudste Eerst',
        mostLiked: 'Hoogste Beoordeling',
        leastLiked: 'Laagste Beoordeling',
        mostExpensive: 'Duurste',
        cheapest: 'Goedkoopste',
      },
      sortOrder: {
        asc: 'oplopend',
        desc: 'aflopend',
      },
      sortBy: {
        createdAt: 'Datum',
        likeCount: 'Likes',
        cost: 'Prijs',
      },
      active: {
        rating: 'Min Beoordeling: {{value}}',
        startDate: 'Van: {{date}}',
        endDate: 'Tot: {{date}}',
        cost: 'Min Prijs: {{value}}',
        radius: 'Binnen {{value}}km',
      },
    },
  },
  languages: {
    en: 'Engels',
    nl: 'Nederlands',
    tr: 'Turks',
    de: 'Duits',
    fr: 'Frans',
    es: 'Spaans',
    it: 'Italiaans',
    pt: 'Portugees',
    select: 'Selecteer taal',
  },
  validation: {
    'place-required': 'Oeps! Kies eerst een plek',
    'category-required': 'Kies een categorie!',
    'review-min-length': 'Vertel wat meer (minimaal 80 tekens)',
    'rating-required': 'Vergeet niet te scoren!',
    'cost-positive': 'Prijs moet meer dan nul zijn',
    'visited-at-required': 'Wanneer was je er?',
    'type-required': 'Eten of drinken?',
    'food-required': 'Wat heb je gegeten?',
    'drink-required': 'Wat heb je gedronken?',
    'country-required': 'Waar kom je vandaan?',
    required: 'Dit veld is verplicht',
  },
  auth: {
    welcomeBack: 'Hey! 👋',
    loginToContinue: 'Spring er weer in',
    continueWithGoogle: 'Ga door met Google',
    continueWithApple: 'Ga door met Apple',
    logout: 'Tot Later! 👋',
    login: 'Inloggen',
    signup: 'Aanmelden',
    signupToContinue: 'Word lid van onze foodie gemeenschap',
    joinCommunity: 'Sluit Je Aan Bij Onze Food Community',
    required: 'Laten We Beginnen!',
    actionRequiresAuth: 'Oeps! Even snel inloggen voor dit',
    alreadyLoggedIn: 'Je bent al ingelogd!',
    goToProfile: 'Ga naar Profiel',
    continueToFeed: 'Ga naar Feed',
    alreadyHaveAccount: 'Heb je al een account?',
    benefits: {
      title: 'Kijk wat je mist:',
      follow: 'Volg je favoriete eten',
      review: 'Deel je food avonturen',
      save: 'Bewaar plekken voor later',
      community: 'Ontmoet andere food lovers',
      personalized: 'Krijg food tips op maat',
    },
    cta: {
      login: 'Lets Go!',
      cancel: 'Misschien Later',
    },
    actions: {
      followFood: 'Log snel in om dit lekkere gerecht te volgen!',
      unfollowFood: 'Log in om te ontvolgen',
    },
    joinNow: 'Join Nu!',
  },
  errors: {
    invalidFileType:
      'Ongeldig bestandstype. Upload alleen JPG, PNG, WebP, HEIC of HEIF afbeeldingen.',
    fileTooLarge: 'Bestand is te groot. Maximum grootte is {{size}}.',
    tooManyFiles: 'Te veel bestanden. Maximum toegestaan is {{max}}.',
  },
  common: {
    noMoreReviews: 'Geen meer reviews',
    save: 'Bewaar Het',
    error: {
      default: 'Oeps!',
      fetchFailed: 'Kon data niet ophalen',
      rateLimitExceeded:
        'Te veel verzoeken. Wacht even en probeer het opnieuw.',
    },
    search: 'Zoek Het',
    back: 'Ga Terug',
    cancel: 'Laat Maar',
    loading: 'Laden...',
    delete: 'Verwijder',
    create: 'Maak Het',
    open: 'Open',
    closed: 'Gesloten',
    country: 'Land',
    reviews: 'Beoordelingen',
    reviews_count: '{{count}} foodies hebben dit geprobeerd',
    showMore: 'Meer Alsjeblieft',
    showLess: 'Minder Alsjeblieft',
    uploadImage: 'Afbeelding Uploaden',
    uploadMedia: 'Media Uploaden',
    deleteMedia: 'Media Verwijderen',
    uploadedMedia: 'Geüploade Media',
    sort: 'Sorteer Op',
    loadMore: 'Meer Laden',
    backToHome: 'Terug naar Home',
    actions: {
      share: {
        label: 'Delen',
        copied: 'Link gekopieerd naar klembord',
        copyFailed: 'Kopiëren naar klembord mislukt',
      },
    },
    exploreMore: 'Ontdek Meer',
    discoverExperiences: 'Ontdek nieuwe culinaire ervaringen',
    reachedEndOfContent: 'Je hebt het einde van deze inhoud bereikt',
    comingSoon: 'Coming Soon',
    notNow: 'Not Now',
    close: 'Close',
    saveChanges: 'Save Changes',
    food: 'food',
    previous: 'Previous',
    next: 'Next',
  },
  profile: {
    follow: 'Volgen',
    unfollow: 'Ontvolgen',
    followers: 'Fans',
    following: 'Volgend',
    avatar: 'Jouw Foto',
    change_avatar: 'Nieuwe Foto',
    upload_avatar: 'Upload Foto',
    title: 'Jouw Profiel',
    view: 'Bekijk Profiel',
    username: 'Gebruikersnaam',
    email: 'Email',
    success: 'Ziet er goed uit!',
    error: 'Oeps, er ging iets mis',
    save: 'Bewaar Het',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    birthDate: 'Geboortedatum',
    country: 'Land',
    bio: 'Over Jou',
    noAccount: 'Nog geen account?',
    bioPlaceholder: 'Vertel ons over je food avonturen...',
    selectCountry: 'Selecteer Jouw Land',
    deleteAccount: {
      button: 'Account Verwijderen',
      title: 'Verwijder Je Account',
      warning:
        'Waarschuwing: Deze actie kan niet ongedaan worden gemaakt. Al je gegevens, beoordelingen en voorkeuren worden permanent verwijderd.',
      confirm: 'Verwijder Mijn Account',
      error: 'Account verwijderen mislukt. Probeer het later opnieuw.',
    },
  },
  onboarding: {
    welcome: 'Welkom bij BiteCritic!',
    setup_profile: 'Laten we je profiel instellen',
    username: 'Gebruikersnaam',
    username_required: 'Gebruikersnaam is verplicht',
    username_min_length: 'Gebruikersnaam moet minimaal 3 tekens bevatten',
    username_pattern: 'Alleen letters, cijfers en underscore zijn toegestaan',
    username_taken: 'Deze gebruikersnaam is al in gebruik',
    username_available: 'Gebruikersnaam is beschikbaar!',
    username_requirements:
      'Gebruikersnaam moet minimaal 3 tekens bevatten en mag alleen letters, cijfers en underscore bevatten',
    checking_username: 'Beschikbaarheid controleren...',
    first_name: 'Voornaam',
    first_name_required: 'Voornaam is verplicht',
    first_name_min_length: 'Voornaam moet minimaal 2 tekens bevatten',
    first_name_max_length: 'Voornaam mag maximaal 20 tekens bevatten',
    last_name: 'Achternaam',
    last_name_required: 'Achternaam is verplicht',
    last_name_min_length: 'Achternaam moet minimaal 2 tekens bevatten',
    last_name_max_length: 'Achternaam mag maximaal 20 tekens bevatten',
    birth_date: 'Geboortedatum',
    birth_date_required: 'Geboortedatum is verplicht',
    country: 'Land',
    complete_profile: 'Profiel Voltooien',
    success: 'Profiel succesvol bijgewerkt!',
    error: 'Profiel bijwerken mislukt',
  },
  language: {
    select: 'Kies Je Taal',
    select_country: 'Waar Ben Je?',
    select_language: 'Welke Taal?',
    current: 'Huidige Taal',
  },
  categories: {
    title: 'Eten Categorieën',
    meta: {
      title: 'Eten Categorieën - Ontdek Culinaire Hoogstandjes',
      description:
        'Verken onze diverse eetcategorieën en ontdek culinaire hoogstandjes van over de hele wereld. Vind beoordelingen, waarderingen en waar je ervan kunt genieten.',
      categoryTitle: 'Eten Categorie',
      categoryDescription:
        'Verken {{category}} - Ontdek {{count}} heerlijke gerechten in deze categorie met beoordelingen en waarderingen van eetliefhebbers.',
      keywords:
        'eetcategorieën, keukensoorten, culinaire verkenning, eten ontdekken',
      loading: 'Categorie Laden',
      defaultDescription:
        'Verken onze diverse eetcategorieën en vind je volgende culinaire avontuur.',
    },
  },
  places: {
    radius: 'Zoekradius (km)',
    noPlacesFound: 'Nog niets hier',
    tryAdjustingFilters: 'Probeer een plek te zoeken of filters aan te passen om meer opties te zien.',
    locationPermission: {
      title: 'Waar wil je verkennen?',
      description: 'Schakel locatie in om geweldige plekken in de buurt te vinden of zoek een specifieke locatie.',
      allow: 'Mijn locatie gebruiken'
    },
    whereDidYouEat: 'Waar heb je dit gegeten?',
    searchByLocation: 'Waar wil je naartoe?',
    selectPlace: 'Zoek een plek...',
    yourLocation: 'Jouw locatie',
    searchOrUseLocation: 'Zoek een plek of gebruik je locatie om te beginnen.',
    locationStatus: {
      detecting: 'Je locatie zoeken...',
      denied: 'Toegang tot locatie geweigerd',
      unavailable: 'Locatie niet beschikbaar',
      found: 'Locatie gevonden!'
    },
    sort: {
      title: 'Sorteren op',
      ratingDesc: 'Hoogste beoordeling', 
      ratingAsc: 'Laagste beoordeling',
      distanceAsc: 'Dichtstbijzijnde eerst',
      distanceDesc: 'Verste eerst',
      nameAsc: 'Naam (A-Z)',
      nameDesc: 'Naam (Z-A)',
      reviewCountDesc: 'Meest beoordeeld',
      reviewCountAsc: 'Minst beoordeeld',
      newestFirst: 'Nieuwste eerst',
      oldestFirst: 'Oudste eerst'
    },
    period: {
      title: 'Tijdsperiode',
      ALL_TIME: 'Alle tijd',
      LAST_WEEK: 'Afgelopen week',
      LAST_MONTH: 'Afgelopen maand',
      LAST_YEAR: 'Afgelopen jaar'
    },
    meta: {
      title: 'Ontdek restaurants bij jou in de buurt',
      description: 'Vind en verken de beste restaurants in jouw omgeving. Lees beoordelingen, bekijk foto\'s en ontdek nieuwe eetbelevingen.',
      titleWithPlace: 'Beste plekken in de buurt van {{place}}',
      descriptionWithPlace: 'Ontdek de beste restaurants en eetgelegenheden in de buurt van {{place}} binnen {{radius}} km. Lees beoordelingen, bekijk ratings en vind jouw volgende favoriete eetplek.'
    },
    navigation: {
      title: 'Plekken',
    },
    detail: {
      error: 'Oeps! We konden deze plek niet vinden. Probeer het opnieuw?',
      sections: {
        popularFoods: {
          title: 'Meest Geliefd bij {{place}}',
          description:
            'Deze gerechten worden het meest gewaardeerd door onze food liefhebbers bij {{place}}. Gerangschikt op beoordelingen en aantal reviews.',
          titleWithCity: 'Meest Geliefd bij {{place}} in {{city}}',
          descriptionWithCity:
            'Deze gerechten worden het meest gewaardeerd door onze food liefhebbers bij {{place}} in {{city}}. Gerangschikt op beoordelingen en aantal reviews.',
        },
        gourmets: {
          title: 'Top Foodies bij {{place}}',
          description:
            'Ontmoet de food liefhebbers die {{place}} het beste kennen. Ze zijn gerangschikt op hun aantal reviews en beoordelingen.',
          titleWithCity: 'Top Foodies bij {{place}} in {{city}}',
          descriptionWithCity:
            'Ontmoet de food liefhebbers die {{place}} in {{city}} het beste kennen. Ze zijn gerangschikt op hun aantal reviews en beoordelingen.',
        },
        reviews: {
          title: 'Reviews voor {{place}}',
          titleWithCity: 'Reviews voor {{place}} in {{city}}',
        },
      },
    },
    emptyState: {
      title: 'Geen plekken gevonden',
      description: '{{username}} heeft nog geen plekken beoordeeld.'
    },
    userMapTitle: 'Foodkaart van {{username}}',
    reviewsDrawer: {
      title: 'Beoordelingen voor {{placeName}}',
      noReviews: 'Nog geen beoordelingen voor deze plek.',
      viewMore: 'Alle beoordelingen bekijken',
      addReview: 'Beoordeling toevoegen'
    },
    viewAllVisited: 'Alle plekken die {{username}} heeft bezocht en beoordeeld'
  },
  settings: {
    title: 'Jouw Instellingen',
  },
  home: 'Home',
  'review-not-found': 'Kan deze review niet vinden',
  'go-back': 'Ga Terug',
  actions: {
    share: 'Vertel Vrienden',
  },
  users: {
    title: 'Eetliefhebbers',
    searchPlaceholder: 'Vind foodies op naam...',
    noResults: 'Geen eetliefhebbers gevonden',
    seoTitle: 'Voedselhobbyisten en Recensenten',
    seoDescription:
      'Ontdek voedselhobbyisten en recensenten in jouw omgeving. Maak contact met eetliefhebbers die jouw culinaire passies delen en ontdek nieuwe eetbelevenissen.',
    seoKeywords:
      'voedselhobbyisten, voedselrecensenten, culinaire experts, eetliefhebbers, food lovers',
    navigation: {
      title: 'Foodies',
    },
    stats: {
      followers: 'Volgers',
      following: 'Volgend',
      rating: 'Score',
      reviews: 'Reviews',
    },
    map: {
      viewMap: 'Bekijk Foodkaart',
      seoTitle: 'Foodkaart van {{username}}',
      seoDescription: 'Ontdek de plaatsen die {{username}} heeft bezocht en beoordeeld op hun Foodkaart.'
    },
    detail: {
      sections: {
        visitedPlaces: {
          title: 'Recent Bezochte Plekken van {{username}}',
          description: 'Plekken waar {{username}} heeft gegeten',
        },
        likedFoods: {
          title: 'Favoriete Gerechten van {{username}}',
          description:
            'Gerechten die {{username}} heeft geprobeerd en beoordeeld',
        },
      },
    },
  },
  foods: {
    title: 'Gerechten',
    meta: {
      title: 'Ontdek Gerechten Bij Jou in de Buurt',
      description:
        "Verken en ontdek heerlijke gerechten in jouw omgeving. Bekijk beoordelingen, ratings en foto's van verschillende gerechten uit lokale restaurants.",
    },
    searchPlaceholder: 'Zoek gerechten...',
    noResults: 'Geen gerechten gevonden',
    sort: {
      nameAsc: 'Naam A-Z',
      nameDesc: 'Naam Z-A',
      ratingDesc: 'Hoogste Waardering',
      ratingAsc: 'Laagste Waardering',
      reviewCountDesc: 'Meeste Reviews',
      reviewCountAsc: 'Minste Reviews',
    },
    period: {
      allTime: 'Alle Tijd',
      lastWeek: 'Afgelopen Week',
      lastMonth: 'Afgelopen Maand',
      lastYear: 'Afgelopen Jaar',
    },
  },
  feed: {
    title: 'Jouw Persoonlijke Voedselreis',
    description:
      'Volg je favoriete gerechten, plekken en mede-foodies om je perfecte voedsel feed te creëren. Ontvang gepersonaliseerde aanbevelingen en mis nooit meer een geweldige maaltijd.',
    discover: 'Begin met Ontdekken',
    personalizedTitle: 'Jouw Voedsel Feed',
    allReviewsTitle: 'Nieuwste Voedsel Verhalen',
    personalizedDescription:
      'Bekijk beoordelingen van de gerechten, plekken en foodies die je volgt.',
    joinCommunityDescription:
      'Word lid van onze gemeenschap voor een gepersonaliseerde feed op basis van jouw interesses.',
    noRelatedReviews:
      'We hebben nog geen beoordelingen die bij jouw interesses passen. Laten we eens kijken naar enkele wereldwijde verhalen!',
    showGlobalFeed: 'Toon Wereldwijde Feed',
    myFeed: 'Mijn Feed',
    globalFeed: 'Wereldwijde Feed',
    globalDescription:
      'Ontdek de nieuwste voedselverhalen van over de hele wereld.',
    noGlobalReviews:
      'Er zijn momenteel geen wereldwijde beoordelingen beschikbaar. Kom snel terug!',
    meta: {
      title: 'Voedsel Feed - Jouw Gepersonaliseerde Voedselreis',
      description:
        'Ontdek de nieuwste voedselbeoordelingen en verhalen van je favoriete gerechten, plekken en foodies. Krijg gepersonaliseerde aanbevelingen op basis van jouw smaak.',
      keywords:
        'voedsel feed, voedselbeoordelingen, gepersonaliseerde aanbevelingen, voedselverhalen, voedselgemeenschap',
    },
    followFoods: {
      title: 'Volg Gerechten',
      description:
        'Houd je favoriete gerechten bij en ontdek nieuwe variaties.',
    },
    followPlaces: {
      title: 'Volg Plekken',
      description:
        'Blijf op de hoogte van de nieuwste beoordelingen van je favoriete locaties.',
    },
    followGourmets: {
      title: 'Volg Foodies',
      description:
        'Maak contact met voedselliefhebbers die jouw smaak delen en ontdek hun aanbevelingen.',
    },
  },
  navigation: {
    home: 'Home',
    discover: 'Ontdekken',
    community: 'Community',
    support: 'Ondersteuning',
    myProfile: 'Mijn Profiel',
    myFeed: 'Mijn Feed',
    gourmets: 'Foodies',
    placesNearMe: 'Plekken in de Buurt',
    foodsNearMe: 'Eten in de Buurt',
    popularPlacesMonth: 'Beste Plekken van de Maand',
    mostReviewedPlacesMonth: 'Meest Besproken Plekken van de Maand',
    popularGourmetsMonth: 'Populaire Foodies van de Maand',
    popularFoodsMonth: 'Populaire Gerechten van de Maand',
    popular: 'Populair',
    contact: 'Contact',
    privacy: 'Privacybeleid',
    terms: 'Algemene Voorwaarden',
  },
  error: {
    pageNotFound: 'Pagina Niet Gevonden',
    pageNotFoundDescription:
      'De pagina die je zoekt is mogelijk verwijderd, hernoemd of tijdelijk niet beschikbaar.',
    needHelp: 'Hulp Nodig?',
    contactUs:
      'Neem contact op met ons ondersteuningsteam, we helpen je graag verder.',
  },
  contact: {
    title: 'Contact',
    name: 'Jouw Naam',
    email: 'Jouw E-mailadres',
    message: 'Jouw Bericht',
    send: 'Verstuur Bericht',
    nameRequired: 'Vul je naam in',
    emailRequired: 'Vul je e-mailadres in',
    emailInvalid: 'Vul een geldig e-mailadres in',
    messageRequired: 'Vul je bericht in',
    pageTitle: 'Neem Contact Op',
    pageDescription:
      'Heb je vragen of hulp nodig? Wij staan voor je klaar! Vul het onderstaande formulier in of stuur ons direct een e-mail.',
  },
  statuses: {
    active: 'Actief',
    pending: 'In Afwachting',
    rejected: 'Afgewezen',
  },
  app: {
    actions: 'App Acties',
  },
  download: {
    ios_app: 'Download iOS App',
    android_app: 'Download Android App',
  },
  notifications: {
    title: 'Meldingen',
    pageTitle: 'Notificaties',
    pageDescription: 'Beheer je notificaties',
    markAllAsRead: 'Alles als gelezen markeren'
  },
  endOfScroll: {
    placesNearMe: 'Plekken in de Buurt',
    placesNearMeSubtitle: 'Vind restaurants en eetgelegenheden in de buurt',
    globalFeed: 'Globale Feed',
    globalFeedSubtitle: 'Zie wat anderen lekker vinden',
    findPeople: 'Vind Foodies',
    findPeopleSubtitle: 'Verbind met andere eetliefhebbers',
    foodsNearMe: 'Eten in de Buurt',
    foodsNearMeSubtitle: 'Ontdek populaire gerechten in jouw omgeving',
  },
  'media': 'Media',
  'media.image': 'Image',
  'media.video': 'Video',
  'location': 'Locatie',
  // New review modal step explanations
  'review-modal-media-explanation': 'Maak een foto of kies er een uit je album om je gerecht te laten zien!',
  'review-modal-rating-explanation': 'Hoe smaakte het? Geef je eerlijke beoordeling.',
  'review-modal-location-explanation': 'Waar heb je dit gerecht gegeten? Laat het anderen weten!',
  // Draft management
  'draft-cleared': 'Concept succesvol gewist!',
  'draft-save-error': 'Oeps! Je concept kon niet worden opgeslagen',
  'clear-draft': 'Concept wissen',
  comments: {
    title: 'Reacties',
    subtitle: 'Doe mee aan het gesprek',
    writeComment: 'Schrijf een reactie...',
    submit: 'Plaatsen',
    delete: 'Verwijderen',
    noComments: 'Nog geen reacties. Wees de eerste die reageert!',
    loginToComment: 'Log in om een reactie te plaatsen',
    loadMore: 'Meer laden',
    commentAdded: 'Reactie succesvol toegevoegd',
    commentError: 'Kon reactie niet toevoegen',
    commentDeleted: 'Reactie verwijderd',
    deleteError: 'Kon reactie niet verwijderen',
    post: 'Plaatsen',
    placeholder: 'Schrijf een reactie...',
  },
  mentions: {
    noUsersFound: 'Geen gebruikers gevonden',
    searchingUsers: 'Zoeken naar gebruikers...',
  },
} as const;

export default translations;
